import { createFileRoute } from '@tanstack/react-router'
import ProjectCaseStudy from '@/components/preview/ProjectCaseStudy'
import { projectCaseStudies } from '@/data/projectCaseStudies'
import { projectStudyHead } from '@/lib/projectStudyHead'

const study = projectCaseStudies['packcraft-india']
export const Route = createFileRoute('/work/packcraft-india')({
  head: () => projectStudyHead(study),
  component: () => <ProjectCaseStudy study={study} />,
})
